/**
 * Figma Node IDs:
 * Design Frame: 1:10985
 * Instance IDs: 4022:5202, 4022:5206, 4022:5208, 4022:5210, 4022:5212, 4022:5214
 * Composite: true
 * Last Updated: 2024-12-23
 * Generated by: Claude Code figma-component command
 */
import React from "react";

import { RichText } from "@learningblocks/shared-components/lib/RichText";

import { baseLabelClass, sizeVariants } from "./Label.css";

type LabelElement = "label" | "span";

export interface LabelProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  htmlFor?: string;
  component?: LabelElement;
  size?: "l" | "m" | "s" | "xs" | "allcaps";
  className?: string;
}

export const Label: React.FC<LabelProps> = ({
  children,
  size = "m",
  className = "",
  component: Component = "label",
  ...rest
}) => {
  const combinedClassName = [baseLabelClass, sizeVariants[size], className]
    .filter(Boolean)
    .join(" ");

  return (
    <Component className={combinedClassName} {...rest}>
      <RichText value={children} />
    </Component>
  );
};
